import InputForm from "./input-form.jsx";
import React, {useEffect, useRef, useState} from "react";
import {Modal} from "../modal/modal.jsx";
import Button from "../button/button.jsx";
import {AdvancedMarker, APIProvider, ControlPosition, Map} from "@vis.gl/react-google-maps";
import {GeocodeAddress} from "../utils/map-utils.jsx";
import InitialAddress from "../../app/web/sos/citizen/form/resources/initial-address.js";

const LatLngInput = ({markerPositionString, setMarkerPositionString, position, corporation, markerPosition, setMarkerPosition, className, disabled, onChange, label}) => {
    const [openModal, setOpenModal] = useState(false);
    const [address, setAddress] = useState(InitialAddress);
    const containerRef = useRef(null);

    function handleMapClick(e) {
        const lat = e.detail.latLng.lat;
        const lng = e.detail.latLng.lng;

        const value = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
        setMarkerPosition({ lat, lng });
        setMarkerPositionString(value);

        if (onChange) onChange?.(value);
    }

    function handleSearch(location) {
        const lat = location.lat();
        const lng = location.lng();

        const value = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
        setMarkerPosition({ lat, lng });
        setMarkerPositionString(value);

        if (onChange) onChange?.(value);
    }

    const closeModal = () => {
        setOpenModal(false);
    };

    const closeModalOkButton = () => {
        setOpenModal(false);
    };

    return(
        <>
            <div className={className} ref={containerRef} onClick={() => {
                if(disabled) return;
                setOpenModal(true)
            }}>
                <InputForm disabled={disabled} readOnly labelClass={[disabled ? "cursor-default!" : "!bg-white cursor-pointer"].join(" ")} inputClass={[disabled ? "cursor-default!" : "!bg-white min-w-[172px] pointer-events-none"].join(" ")} value={markerPositionString} label={label}/>
            </div>
            <Modal title="Mapa" open={openModal} setOpen={closeModal} className="w-7/12">
                <Modal.Body className="p-0 !m-0 align-self-center justify-items-center">
                    <APIProvider apiKey={corporation?.maps_api_key ?? ""} language={"pt-BR"} libraries={["places"]}>
                        <Map
                            mapId="a7e2dbd01b9a18afb82d00c6"
                            defaultZoom={13}
                            fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                            reuseMaps={true}
                            defaultCenter={position}
                            streetViewControl={false}
                            scrollwheel={true}
                            gestureHandling={'greedy'}
                            style={{ height: "calc(-250px + 100vh)", width: "100%" }}
                            mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                            onClick={handleMapClick}

                        >
                            <GeocodeAddress address={address} changeLocation={handleSearch}/>
                            <AdvancedMarker
                                position={markerPosition ?? position}
                            />
                        </Map>
                    </APIProvider>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={closeModalOkButton}>Ok</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default LatLngInput;